// 엑셀 칸의 숫자·금액 읽기 — 붙여넣기·시트·엑셀 가져오기가 이 한 벌을 쓴다.

/**
 * 숫자 칸을 읽는다. 엑셀은 천단위 쉼표·원화 기호를 섞어 준다.
 *
 * **못 읽으면 `null`** 이다. 0 으로 눌러 버리면 `32㎡`·`7,000원/㎡` 처럼 단위가
 * 붙은 칸이 0원으로 들어가고, 화면은 「담았습니다」 만 말한다.
 *
 * 음수도 못 읽은 것으로 본다 — 견적의 수량·단가에 음수 자리는 없고, 회계식
 * 괄호 표기 `(5,000)` 를 -5,000 으로 들이면 저장 직전에야 막힌다.
 */
export const parseNumber = (raw: string): number | null => {
  const text = raw.trim();
  if (text === "") return 0;

  // 쉼표·원화 기호·공백·끝의 「원」 까지는 봐준다. 그 밖의 글자가 남으면 못 읽은 것.
  const cleaned = text.replace(/[,₩\s]/g, "").replace(/원$/, "");
  // 소수점만 있고 한쪽이 빈 것(`.5` · `5.`)도 받는다 — 엑셀이 그렇게 내보내기도 한다.
  // 숫자가 한 자도 없으면(`.` · `-`) 못 읽은 것이다.
  if (!/^\d*\.?\d*$/.test(cleaned) || !/\d/.test(cleaned)) return null;

  const value = Number(cleaned);
  return Number.isFinite(value) ? value : null;
};

/**
 * 금액 칸을 읽는다. **소수는 못 읽은 것으로 본다.**
 *
 * 스키마의 `money` 가 정수만 받는데(`z.number().int()`) `parseNumber` 는
 * `12,000.5` 를 12000.5 로 정상 인식했다. 그러면 화면은 「담았습니다」 라고만
 * 말하고 편집기에 120,005원처럼 보이다가, 저장 버튼을 눌러서야 「금액은 정수여야
 * 합니다」 가 뜬다 — **「못 읽은 것은 빠짐없이 말한다」 는 이 파일의 원칙이 새는
 * 자리였다.**
 *
 * 수량은 그대로 `parseNumber` 를 쓴다. DB 가 `numeric(14,3)` 이라 소수가 맞다.
 */
export const parseMoney = (raw: string): number | null => {
  const value = parseNumber(raw);
  if (value === null) return null;
  return Number.isInteger(value) ? value : null;
};
